// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3944":"css/app.7068","7719":"css/admin-app.7068"}[chunkId] + ".css";
};